import React from 'react';
import { ChevronRight } from 'lucide-react';

const DPPCard = ({ theme, title, icon: Icon, iconBgColor, iconColor, onClick, className = "" }) => {
    return (
        <div
            className={`flex flex-row items-center justify-center text-center px-2 py-4 w-full h-auto rounded-lg cursor-pointer ${className}`}
            style={{ 
                backgroundColor: theme.background2,
                border: `1px solid ${theme.stroke}`
            }}
            onClick={onClick}
        >
            <div className="flex flex-row items-center justify-start text-left w-full h-auto gap-4 px-2">
                <div className="flex items-center justify-center w-10 h-10 rounded-full flex-shrink-0"
                    style={{ backgroundColor: iconBgColor }}>
                    <Icon size={20} style={{ color: iconColor }} />
                </div>
                <h3 className="font-semibold" style={{ color: theme.text }}>
                    {title}
                </h3>
            </div>
            <div className="p-1" style={{ color: theme.text }}>
                <ChevronRight size={24} />
            </div>
        </div>
    );
};

export default DPPCard;
